// extracted by mini-css-extract-plugin
export default {"container":"DeliverablesList_container__p3Xhr"};